import script from "./ProductRequirement.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductRequirement.vue?vue&type=script&lang=ts&setup=true"

import "./ProductRequirement.vue?vue&type=style&index=0&id=680e86f2&lang=scss"

const __exports__ = script;

export default __exports__